import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Popconfirm,
  Form,
  Space,
  Col,
  Row,
  message,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { ReactComponent as EditIcon } from "../../assets/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../assets/delete-icon.svg";
import { ReactComponent as CrossIcon } from "../../assets/crossIcon.svg";
import { ReactComponent as SaveIcon } from "../../assets/save-icon.svg";
import SpinnerComponent from "../../components/spinner";
// import CustomPagination from "../../components/customPagination/CustomPagination";
import {
  createSupplier,
  deleteSupplier,
  fetchSuppliers,
  isAddingAction,
  updateSupplier,
} from "./redux/actions";
import _ from "lodash";

const SuppliersTable = ({ canUpdate }) => {
  const [sortedInfo, setSortedInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editingLoading, setEditingLoading] = useState(false);
  const [editingKey, setEditingKey] = useState("");
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [page, setPage] = useState(() => 1);
  const [resultPerPage, setResultPerPage] = useState(() => 10);
  const [req, setReq] = useState(false);
  const [search, setSearch] = useState({});
  const [searchedData, setSearchedData] = useState([]);
  const [defaultPageOneReq, setDefaultPageOneReq] = useState(false);

  const isEditing = (record) => record.id === editingKey;

  const { allSuppliers, fetchingLoading, updateLoading, isAdding } =
    useSelector((state) => state.supplierTypeReducer);

  useEffect(() => {
    if (page && resultPerPage && page > 0 && resultPerPage > 0) {
      dispatch(fetchSuppliers({ page: page, limit: resultPerPage, search, orderBy: 'name', orderDirection: 'asc' }));
    }

    return () => {
      dispatch(isAddingAction(false));
    };
  }, [req]);

  useEffect(() => {
    let paramsPage = 1;
    if (paramsPage && resultPerPage && paramsPage > 0 && resultPerPage > 0) {
      dispatch(
        fetchSuppliers({ page: paramsPage, limit: resultPerPage, search, orderBy: 'name', orderDirection: 'asc' })
      );
      setPage(1);
    }
  }, [defaultPageOneReq]);

  useEffect(() => {
    setLoading(fetchingLoading);
  }, [fetchingLoading]);

  useEffect(() => {
    setEditingLoading(updateLoading);
    if (!updateLoading) {
      setEditingKey("");
    }
  }, [updateLoading]);

  useEffect(() => {
    setData(allSuppliers);
    setSearchedData(allSuppliers);
  }, [allSuppliers]);

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode = (
      <Input
        placeholder="Insert Supplier"
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            save(record.id);
          }
        }}
      />
    );
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `This field is required!`,
              },
              {
                min: 1,
                message: `invalid!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  const edit = (record) => {
    dispatch(isAddingAction(true));

    form.setFieldsValue({
      supplier: "",
      ...record,
    });
    setEditingKey(record.id);
  };

  const cancel = (record) => {
    dispatch(isAddingAction(false));
    form.resetFields();
    setEditingKey("");
    if (record?.isAdd) {
      return setSearchedData((data) =>
        data.filter((el) => el.id !== record.id)
      );
    } else {
      setSearchedData(searchedData);
    }
  };

  const save = async (id) => {
    try {
      const row = await form.validateFields();
      const newData = [...searchedData];
      const index = newData.findIndex((item) => id === item.id);

      if (index > -1) {
        const item = newData[index];
        if (item?.isAdd) {
          form.submit();
        } else {
          dispatch(updateSupplier({ ...item, ...row }));
        }
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
      message.error("Name should not be blank!");
    }
  };

  const handleDelete = (record) => {
    setEditingKey(record.id);
    dispatch(deleteSupplier(record));
  };

  const handleAdd = () => {
    dispatch(isAddingAction(true));
    let id = Math.floor(Math.random() * 1122123456);
    const newData = {
      id,
      name: "",
      isAdd: true,
    };
    setSearchedData((data) => [newData, ...data]);
    setEditingKey(id);
    edit(newData);
  };

  const handleFinish = ({ name }) => {
    if (name.trim().length < 1) {
      return message.error("Name should not be blank.");
    }

    let filtered = data.filter(
      (el) => el.name.toLowerCase() === name.toLowerCase()
    );

    if (filtered.length > 0) {
      return message.error("Name has already been taken.");
    }

    dispatch(createSupplier({ name: name.trim() }));
  };

  const searchInput = (key) => (
    <Input
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        const { value } = e.target;

        if (value.length < 1) {
          return setSearchedData(data);
        }

        let filteredData = data.filter((el) =>
          el.name.toLowerCase().includes(value.toLowerCase())
        );

        setSearchedData(filteredData);
      }}
    />
  );
  const searchFunc = (toSearch, Data) => {
    let terms = toSearch.split(" ");
    return Data.filter((object) =>
      terms.every((term) =>
        Object.values(object).some((value) => value.toString().includes(term))
      )
    );
  };
  const columns = [
    {
      title: () => {
        return (
          <div
            align="top"
            className="select-parent-div"
            style={{
              paddingLeft: "10px",
            }}
          >
            <div className="special-table-header-text">Supplier</div>
            <div>{searchInput("name")}</div>
          </div>
        );
      },
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      sortOrder: sortedInfo?.columnKey === "name" && sortedInfo?.order,
      width: "50%",
      editable: true,
      render: (name) => <div style={{ paddingLeft: "10px" }}>{name}</div>,
    },
    {
      title: "",
      key: "action",
      dataIndex: "",
      width: "50%",
      align: "right",
      render: (_, record) => {
        if (!canUpdate) {
          return;
        }

        const editable = isEditing(record);
        return editable ? (
          editingLoading && editingKey === record.id ? (
            <SpinnerComponent fontSize={14} />
          ) : (
            <Space size={15} align="center">
              <SaveIcon
                className="custom-icon"
                onClick={() => save(record.id)}
              />
              <Popconfirm
                title="Are you sure you want to cancel?"
                onConfirm={() => cancel(record)}
                okText="Yes"
                cancelText="No"
              >
                <CrossIcon
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                  className="custom-icon"
                />
              </Popconfirm>
            </Space>
          )
        ) : (
          <Space size={15} align="center">
            <EditIcon
              className={`custom-icon ${isAdding ? "disable-icon" : ""}`}
              disabled={editingKey !== ""}
              onClick={() => !isAdding && edit(record)}
            />
            {data.length >= 1 &&
              (isAdding ? (
                <DeleteIcon className={`custom-icon disable-icon`} />
              ) : (
                <Popconfirm
                  title="Are you sure you want to delete this Supplier?"
                  onConfirm={() => handleDelete(record)}
                  okText="Yes"
                  cancelText="No"
                  placement="right"
                >
                  <DeleteIcon className="custom-icon" />
                </Popconfirm>
              ))}
          </Space>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Row className="production-manager-parent-row card-container">
      <Col span={24} className="heading-col">
        <Row align="middle" gutter={[30, 0]}>
          <Col>
            <div>
              <span className="heading-span">Suppliers Manager</span>
            </div>
          </Col>
          <Col>
            {canUpdate && (
              <Button
                icon={<PlusOutlined />}
                className="add-activity-btn"
                size="middle"
                disabled={isAdding}
                onClick={handleAdd}
                style={{
                  width: "105%",
                }}
              >
                SUPPLIER
              </Button>
            )}
          </Col>
        </Row>
      </Col>

      <Col span={24}>
        <Form form={form} component={false} onFinish={handleFinish}>
          <Table
            className="special-table supplier-table"
            style={{ width: '40%' }}
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            scroll={{ x: true }}
            rowClassName="editable-row"
            dataSource={searchedData}
            // dataSource={data}
            loading={loading}
            columns={mergedColumns}
            onChange={handleChange}
            pagination={false}
          />
        </Form>
      </Col>
    </Row>
  );
};

export default SuppliersTable;
